import type { FC, ReactNode } from "react";
import * as Tabs from "@radix-ui/react-tabs";
import styles from "./Tab.module.css";

export interface TabItem {
  id: string;
  label: string;
  content: ReactNode;
}

interface TabProps {
  tabs: TabItem[];
  defaultTab?: string;
  onSelectTab?: (tabId: string) => void;
  className?: string;
}

export const Tab: FC<TabProps> = ({
  tabs,
  defaultTab,
  onSelectTab,
  className,
}) => {
  return (
    <Tabs.Root
      className={`${styles.tabContainer} ${className || ""}`}
      defaultValue={defaultTab || tabs[0]?.id}
      onValueChange={onSelectTab}
    >
      <Tabs.List className={styles.tabList} aria-label="tabs">
        {tabs.map((tab) => (
          <Tabs.Trigger
            key={tab.id}
            className={styles.tabButton}
            value={tab.id}
          >
            {tab.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Content key={tab.id} className={styles.tabContent} value={tab.id}>
          {tab.content}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
};
